module.exports = __webpack_public_path__ + "media/images/logo-7c8c02e52b2eda7edcbf9dd659dcd232.png";